import { DEFAULT_DATE_FORMAT } from '@sophocles/app/constants';
import { CicStatusHistory, cicStatusHistorySchema } from '@sophocles/entities/CicStatusHistory/cicStatusHistoryRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { endOfDay, format, parseISO, startOfDay } from 'date-fns';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_CIC_STATUS_HISTORIES = 'RECEIVE_CIC_STATUS_HISTORIES';
function receiveCicStatusHistories(json) {
  return {
    type: RECEIVE_CIC_STATUS_HISTORIES,
    cicStatusHistories: mapListToRecords(json, CicStatusHistory),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CIC_STATUS_HISTORY = 'REQUEST_CIC_STATUS_HISTORY';
function requestCicStatusHistory(cicStatusHistory_id) {
  return {
    type: REQUEST_CIC_STATUS_HISTORY,
    cicStatusHistory_id,
  };
}

export const REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE = 'REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE';
function requestCicStatusHistoryForUnitWithRange(cic_id, from, to) {
  return {
    type: REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE,
    cic_id,
    from,
    to,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCicStatusHistory(cicStatusHistory_id) {
  return dispatch => {
    dispatch(requestCicStatusHistory(cicStatusHistory_id));
    return apiClient
      .get(`/cicstatushistories/${cicStatusHistory_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'cicStatusHistories', cicStatusHistorySchema))
      .then(json => dispatch(receiveCicStatusHistories(json.entities.cicStatusHistories)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CIC_STATUS_HISTORY)));
  };
}

export function fetchCicStatusHistoriesForUnitWithRange(cic_id, from, to) {
  const fromTS = startOfDay(parseISO(from));
  const toTS = endOfDay(parseISO(to));

  const fromString = encodeURIComponent(format(fromTS, DEFAULT_DATE_FORMAT));
  const toString = encodeURIComponent(format(toTS, DEFAULT_DATE_FORMAT));

  return dispatch => {
    dispatch(requestCicStatusHistoryForUnitWithRange(cic_id, fromTS, toTS));
    return apiClient
      .get(`/camerainterfacecontrollers/${cic_id}/status_history/`, {
        params: { receive_time__gte: fromString, receive_time__lte: toString },
      })
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'cicStatusHistories', cicStatusHistorySchema))
      .then(json => dispatch(receiveCicStatusHistories(json.entities.cicStatusHistories)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CIC_STATUS_HISTORY_FOR_UNIT_WITH_RANGE)));
  };
}

/* Edit Actions */
export const EDIT_CIC_STATUS_HISTORY = 'EDIT_CIC_STATUS_HISTORY';
export function editCicStatusHistory(cicStatusHistory_id) {
  return {
    type: EDIT_CIC_STATUS_HISTORY,
    cicStatusHistory: cicStatusHistory_id,
  };
}

export function patchCicStatusHistory(cicStatusHistory_id, values) {
  return dispatch => {
    dispatch(editCicStatusHistory(cicStatusHistory_id));
    return apiClient
      .patch(`/cicstatushistories/${cicStatusHistory_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, cicStatusHistorySchema))
      .then(json => dispatch(receiveCicStatusHistories(json.entities.cicStatusHistories)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_CIC_STATUS_HISTORY)));
  };
}

/* Create Actions */
export const CREATE_CIC_STATUS_HISTORY = 'CREATE_CIC_STATUS_HISTORY';
function sayCreateCicStatusHistory(values) {
  return {
    type: CREATE_CIC_STATUS_HISTORY,
    values: values,
  };
}

export function createCicStatusHistory(values) {
  return dispatch => {
    dispatch(sayCreateCicStatusHistory(values));
    return apiClient
      .post(`/cicstatushistories/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, cicStatusHistorySchema))
      .then(json => dispatch(receiveCicStatusHistories(json.entities.cicStatusHistories)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_CIC_STATUS_HISTORY)));
  };
}

/* Delete Actions */
export const DELETE_CIC_STATUS_HISTORY = 'DELETE_CIC_STATUS_HISTORY';
function sayDeleteCicStatusHistory(cicStatusHistory_id) {
  return {
    type: DELETE_CIC_STATUS_HISTORY,
    cicStatusHistory: cicStatusHistory_id,
  };
}

export function deleteCicStatusHistory(cicStatusHistory_id) {
  return dispatch =>
    apiClient
      .delete(`/cicstatushistories/${cicStatusHistory_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteCicStatusHistory(cicStatusHistory_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_CIC_STATUS_HISTORY)));
}
